module.exports = __webpack_public_path__ + "static/media/kadinsky-11.9c0d63a2.jpeg";